<template>
	<select>
		<slot></slot>
	</select>
</template>

<script>
	import 'assets/plugins/select2/css/select2.min.css'
	import 'assets/plugins/select2/js/select2.min.js'

	export default {
		name: 'Select2',
		props: ['options', 'value', 'readonly'],
		mounted: function() {
			var vm = this
			$(this.$el)
				// init select2
				.select2({
					data: this.options,
					readonly: true
				})
				.val(this.value)
				.trigger('change')
				// emit event on change.
				.on('change', function() {
					vm.$emit('input', this.value)
				});
			$(this.$el).prop("disabled", vm.readonly);
		},
		watch: {
			value: function(value) {
//				console.log(value);
				// update value
				$(this.$el).val(value).trigger('change');
			},
			options: function(options) {
				// update options
				$(this.$el).select2({
					data: options
				})
				//.val(null).trigger('change');
			},
			readonly: function(value) {
				$(this.$el).prop("disabled", value);
			}
		},
		destroyed: function() {
			$(this.$el).off().select2('destroy')
		}

	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Select2.vue?650cb2c8